module.exports = __webpack_public_path__ + "img/ofimatica.5de5c3ad.jpg";